module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-list"
  }, [_c('div', {
    staticClass: "cards",
    style: (_vm.gridConfig)
  }, _vm._l((_vm.shownFilteredProducts), function(product) {
    return _c('EcommerceFilterCard', {
      key: product.id,
      attrs: {
        "product": product
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "cards-mobile"
  }, _vm._l((_vm.shownFilteredProducts), function(product) {
    return _c('EcommerceFilterCard', {
      key: product.id,
      attrs: {
        "product": product
      }
    })
  })), _vm._v(" "), (_vm.shownFilteredProducts.length < _vm.filteredProducts.length && !_vm.isSeeingAll) ? _c('div', {
    staticClass: "see-all",
    on: {
      "click": function($event) {
        _vm.$store.dispatch('updateIsSeeingAll', true)
      }
    }
  }, [_vm._v("\n    See All\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edb4bdc4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!./~/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./src/components/ecommerce/filter/ResultList.vue
// module id = 736
// module chunks = 0